import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faPercent, faSnowflake, faTicketSimple } from '@fortawesome/pro-regular-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader, ModalTitle, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useResetOnfidoMutation } from './certification-details.slice';
import { StyledButtonsRow, StyledInfoBoxWithBorder, StyledInfoIcon, StyledResetButton } from './certification-details.styles';
import type { CertificationActionButtonsProps } from './certification-details.types';
export const CertificationActionButtons = ({
  isPurchaseSelected,
  certificationData
}: CertificationActionButtonsProps) => {
  const [resetOnfido, {
    isLoading: isResetting
  }] = useResetOnfidoMutation();
  const handleResetOnfido = async () => {
    const certificationId = certificationData?.data?.latestAttempt?._id;
    if (!certificationId) {
      NotificationDispatch('error', 'No certification attempt found to reset');
      return;
    }
    try {
      await resetOnfido({
        certificationId
      }).unwrap();
      NotificationDispatch('success', 'Onfido verification URL reset successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
  };
  return <StyledButtonsRow data-testid="certification-details-buttons" data-sentry-element="StyledButtonsRow" data-sentry-component="CertificationActionButtons" data-sentry-source-file="certification-action-buttons.tsx">
      <Button variant="outlined" color="secondary" isDisabled={isPurchaseSelected} data-sentry-element="Button" data-sentry-source-file="certification-action-buttons.tsx">
        <FontAwesomeIcon icon={faTicketSimple} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="certification-action-buttons.tsx" />
        Apply free voucher
      </Button>
      <Button variant="outlined" color="secondary" isDisabled={isPurchaseSelected} data-sentry-element="Button" data-sentry-source-file="certification-action-buttons.tsx">
        <FontAwesomeIcon icon={faPercent} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="certification-action-buttons.tsx" />
        Add discount
      </Button>
      <Modal isSmall triggerElement={<Button variant="outlined" color="secondary" isDisabled={!isPurchaseSelected || !certificationData?.data?.latestAttempt}>
            <FontAwesomeIcon icon={faTrash} />
            Reset Onfido
          </Button>} data-sentry-element="Modal" data-sentry-source-file="certification-action-buttons.tsx">
        <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="certification-action-buttons.tsx">
          <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="certification-action-buttons.tsx">Reset Onfido</ModalTitle>
        </ModalHeader>
        <main>
          <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="certification-action-buttons.tsx">Are you sure you want to reset this Onfido for this user?</ModalDescription>
          <StyledInfoBoxWithBorder data-sentry-element="StyledInfoBoxWithBorder" data-sentry-source-file="certification-action-buttons.tsx">
            <StyledInfoIcon icon={faInfoCircle} data-sentry-element="StyledInfoIcon" data-sentry-source-file="certification-action-buttons.tsx" />
            Remind the user to refresh the page after the reset.
          </StyledInfoBoxWithBorder>
        </main>
        <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="certification-action-buttons.tsx">
          <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="certification-action-buttons.tsx" />
          <StyledResetButton variant="solid" color="primary" onClick={handleResetOnfido} isLoading={isResetting} isDisabled={isResetting} data-sentry-element="StyledResetButton" data-sentry-source-file="certification-action-buttons.tsx">
            Reset Onfido
          </StyledResetButton>
        </ModalFooter>
      </Modal>
      <Button variant="outlined" color="secondary" isDisabled={!isPurchaseSelected || !certificationData?.data?.latestAttempt} data-sentry-element="Button" data-sentry-source-file="certification-action-buttons.tsx">
        <FontAwesomeIcon icon={faSnowflake} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="certification-action-buttons.tsx" />
        Remove cooldown
      </Button>
    </StyledButtonsRow>;
};